export default __webpack_public_path__ + "static/media/Group1857PDF.f937afa9.svg";